import type { Program } from "@/types/program";

export function shortDate(value: string) {
  return new Date(value).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
}

/** Same naming rule as the programs list: the default program has no name of its own. */
export function programDisplayName(program: Program) {
  if (program.isDefault && (!program.name || program.name === "Default Program")) {
    return "Discoverable Program";
  }
  return program.name || "Custom Program";
}
